import { render, staticRenderFns } from "./MainStats.vue?vue&type=template&id=4dbbc2d2&"
import script from "./MainStats.vue?vue&type=script&lang=js&"
export * from "./MainStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports